import type { StateCreator } from 'zustand';

export interface CampaignSlice {
  campaign: {
    finishedRegistration: boolean;
    setFinishedRegistration: (finishedRegistration: boolean) => void;
    expanded: boolean;
    setExpanded: (expanded: boolean) => void;
    wasAutoExpanded: boolean;
    autoExpand: () => void;
  };
}

/**
 * Tracks the state of the campaign prompt, since this state has to be
 * persisted across sessions.
 */
export const createCampaignSlice: StateCreator<CampaignSlice> = (set, get) => ({
  campaign: {
    finishedRegistration: false,
    setFinishedRegistration: (finishedRegistration: boolean) =>
      set({ campaign: { ...get().campaign, finishedRegistration } }),
    expanded: false,
    setExpanded: (expanded: boolean) =>
      set({ campaign: { ...get().campaign, expanded } }),
    wasAutoExpanded: false,
    autoExpand: () => {
      const { wasAutoExpanded } = get().campaign;

      if (wasAutoExpanded) {
        return;
      }

      set({
        campaign: {
          ...get().campaign,
          expanded: true,
          wasAutoExpanded: true,
        },
      });
    },
  },
});
